// extracted by mini-css-extract-plugin
module.exports = {"stickyBar":"seo-form_stickyBar__VJAvt"};